import styled from "styled-components";

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${(props) => (props.margin ? props.margin : "0")};
  font-size: ${(props) => props.size || "16px"};
`;
